import { makeSvgIcon } from '../makeSvgIcon'

export const eye = makeSvgIcon(
  <path d="M12 6C21 6 24 12 24 12C24 12 21 18 12 18C3 18 0 12 0 12C0 12 3 6 12 6Z" />
)
